<template>
     <el-container class="pagination-list process-usage">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="开始时间">
                <el-date-picker v-model="conditions.startTime" type="datetime" placeholder="请选择时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
                <el-date-picker v-model="conditions.endTime" type="datetime" placeholder="请选择时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="流程名称">
                <el-input v-model="conditions.processName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-button class="search-button" @click="search">查询</el-button>
          </el-form>
            <div class="table-list">
              <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%" empty-text="暂无数据">
                <template  v-for="(col,index) in cols" >
                  <el-table-column :key="index"
                  :formatter="formatter"
                  :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip>
                  </el-table-column>
                </template>
                </el-table>
                <el-footer height="32px" class="pagination-footer">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                  </el-pagination>
                </el-footer>
           </div>
        </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ProcessUsage',
  data () {
    return {
      conditions: { processName: '', startTime: '', endTime: '' },
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      cols: [
        {prop: 'name', label: '流程名称'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'startTotal', label: '发起总数'},
        {prop: 'completeTotal', label: '完成总数'},
        {prop: 'notCompleteTotal', label: '未完成总数'},
        {prop: 'lastStartTime', label: '最近使用时间'}
      ],
      filters: {}
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'processName': this.conditions.processName,
        'startTime': this.conditions.startTime ? moment(this.conditions.startTime).format('YYYY-MM-DD HH:mm:ss') : this.conditions.startTime,
        'endTime': this.conditions.endTime ? moment(this.conditions.endTime).format('YYYY-MM-DD HH:mm:ss') : this.conditions.endTime
      }
      this.getTableData()
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters

      this.$axios.get('/process-api/processes/getUsage', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if (this.pagination.total && (this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.process-usage {
  .el-main {
    >.content {
      .el-form {
        margin-bottom: 18px;
      }
      .search-button {
        padding: 4px 5px;
        margin-top: 2px;

      }
     .el-input {
      width: 140px;
     }
    }
    .table-list {
      .el-table__fixed-right {
       box-shadow: none;
       .el-table__fixed-header-wrapper{
        tr th:nth-last-of-type(1){
          border-right: none;
        }
       }
      }
      .del-row {
        color:  #A5A5A5;

        &:hover {
          color: #FB9391;
        }

        &:active {
          color: #FB9391;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/process-usage.vue